import * as React from 'react';
import ActiveMap from './ActiveMap';
import PageInfo from "../../../common/PageInfo/PageInfo";
import TrackableElement from "../../../common/TrackableElement";
import * as styles from "./ActiveWorldMap.module.scss";

class ActiveWorldMap extends React.Component {
  constructor(props) {
    super(props);
    this.scroller = React.createRef();
  }

  componentDidMount() {
    this.scroller.current.scrollLeft += 350;
  }

  render() {
    return (
      <section className={styles.root}>
        <div className={styles.containerWrapper}>
          <div className={styles.mapContainer} ref={this.scroller}>
            <div>
              <ActiveMap />
            </div>
            <div className={styles.countryContainer}>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Eesti"
                  className={styles.countryName}
                  style={{ left: '48%' }}
                  target="_blank"
                  href="https://flatfy.ee"
                >
                  Eesti
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Polska"
                  className={styles.countryName}
                  style={{ left: '42%' }}
                  target="_blank"
                  href="https://flatfy.pl"
                >
                  Polska
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Česká republika"
                  className={styles.countryName}
                  style={{ left: '35%' }}
                  target="_blank"
                  href="https://flatfy.cz"
                >
                  Česká republika
                </TrackableElement>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Україна"
                  className={styles.countryName}
                  style={{ left: '35%' }}
                  target="_blank"
                  href="https://flatfy.ua"
                >
                  Україна
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Magyarország"
                  className={styles.countryName}
                  style={{ left: '30%' }}
                  target="_blank"
                  href="https://hu.flatfy.com"
                >
                  Magyarország
                </TrackableElement>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="România"
                  className={styles.countryName}
                  style={{ left: '30%' }}
                  target="_blank"
                  href="https://flatfy.ro"
                >
                  România
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="България"
                  className={styles.countryName}
                  style={{ left: '42%' }}
                  target="_blank"
                  href="https://bg.flatfy.com"
                >
                  България
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Türkiye Cumhuriyeti"
                  className={styles.countryName}
                  style={{ left: '52%' }}
                  target="_blank"
                  href="https://tr.flatfy.com"
                >
                  Türkiye Cumhuriyeti
                </TrackableElement>
              </div>
            </div>
          </div>
          <PageInfo text='09 - flatfy local' />
        </div>
      </section>
    )
  }
}

export default ActiveWorldMap;
